import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {Router} from "@angular/router";

@Component({
  selector: 'app-info-dialog',
  templateUrl: './insurance-providers-list-dialog.component.html',
  styleUrls: ['./insurance-providers-list-dialog.component.scss']
})
export class InsuranceProvidersListDialogComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<InsuranceProvidersListDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private router: Router) {
  }

  ngOnInit() {
  }

  closeDialog() {
    this.dialogRef.close();
  }

  redirectToSearchByProviderId(provider: any) {
    this.dialogRef.close();

    return this.router.navigate(['search'], {queryParams: {providerId: provider.key, specId: 9, serviceType: 1 } });
  }
}

